import Decimal from "decimal.js";
import { Profiles } from "variables/charts";

export const IsEmpty = (object) => {
  if (typeof object === "undefined" || object === null) {
    return true;
  }
  if (Array.isArray(object) && object.length === 0) {
    return true;
  }
  if (typeof object === "string" && object.trim().length === 0) {
    return true;
  }
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      return false;
    }
  }
  return true;
};

export const IsNotEmpty = (object) => !IsEmpty(object);

export const OnlyNumbers = (t = "") => t.replace(/[^\d]/gi, "");

export const checkProfiles = (allowedProfiles, credenciais) => {
  if (allowedProfiles && credenciais) {
    return allowedProfiles.some((y) => credenciais.includes(y));
  }
};

export const maskCpfCnpj = (v) => {
  v = v.replace(/\D/g, "");

  if (v.length <= 11) {
    v = v.replace(/(\d{3})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  } else {
    v = v.replace(/^(\d{2})(\d)/, "$1.$2");
    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
    v = v.replace(/(\d{4})(\d)/, "$1-$2");
  }
  return v;
};

export const maskCep = (v) => {
  if (v.length === 8) {
    v = v.replace(/\D/g, "");
    v = v.replace(/(\d{2})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d)/, "$1-$2");
    return v;
  }
};

export const maskHour = (v) => {
  v = v.replace(/\D/g, "");
  v = v.replace(/(\d{2})(\d)/, "$1:$2");
  v = v.replace(/(\d{2})(\d)/, "$1:$2");
  return v;
};

export const maskCelular = (v) => {
  v = v.replace(/\D/g, "");

  if (v.length <= 10) {
    v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
    v = v.replace(/(\d{4})(\d)/, "$1-$2");
  } else {
    v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
    v = v.replace(/(\d{5})(\d)/, "$1-$2");
  }

  return v;
};
export const maskDatainfor = (v) => {
  v = v.replace(/\D/g, "");
  let formattedValue = "";
  for (let i = 0; i < v.length; i++) {
    if (i === 2 || i === 4) {
      formattedValue += "/";
    }
    formattedValue += v[i];
  }
  return formattedValue;
};
export const maskOnlyNumbers = (value) => {
  return value.replace(/\D/g, "");
};

export const isDateStringValid = (dateString) => {
  const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
  if (!dateRegex.test(dateString)) {
    return false;
  }
  const parts = dateString.split("/").map((part) => parseInt(part, 10));
  const day = parts[0];
  const month = parts[1];
  const year = parts[2];

  if (day === 0 || day > 31) {
    return false;
  }
  if (month === 0 || month > 12) {
    return false;
  }
  if (year < 1900 || year > 2100) {
    return false;
  }
  return true;
};

export const formatarNomeCompleto = (nome) => {
  const palavrasMinusc = ["da", "de", "do", "dos", "das"];

  return nome
    .split(" ")
    .map((palavra, index) => {
      if (index === 0 || !palavrasMinusc.includes(palavra.toLowerCase())) {
        return palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase();
      } else {
        return palavra.toLowerCase();
      }
    })
    .join(" ");
};

export const maskNumeroMidia = (value) => {
  return "xxxx xxxx xxxx " + value;
};

export const maskNumeroMidiaAssociada = (numero) => {
  const regex = /(\d{4})(\d{4})(\d{4})(\d{4})/;
  const matches = numero.match(regex);

  if (matches) {
    return `${matches[1]}-${matches[2]}-${matches[3]}-${matches[4]}`;
  }

  return numero;
};

export const removerTracos = (numero) => {
  return numero.replace(/-/g, "");
};

export const ufSelect = [
  { value: "", label: "" },
  { value: "AC", label: "Acre" },
  { value: "AL", label: "Alagoas" },
  { value: "AP", label: "Amapá" },
  { value: "AM", label: "Amazonas" },
  { value: "BA", label: "Bahia" },
  { value: "CE", label: "Ceará" },
  { value: "DF", label: "Distrito Federal" },
  { value: "ES", label: "Espírito Santo" },
  { value: "GO", label: "Goiás" },
  { value: "MA", label: "Maranhão" },
  { value: "MT", label: "Mato Grosso" },
  { value: "MS", label: "Mato Grosso do Sul" },
  { value: "MG", label: "Minas Gerais" },
  { value: "PA", label: "Pará" },
  { value: "PB", label: "Paraíba" },
  { value: "PR", label: "Paraná" },
  { value: "PE", label: "Pernambuco" },
  { value: "PI", label: "Piauí" },
  { value: "RJ", label: "Rio de Janeiro" },
  { value: "RN", label: "Rio Grande do Norte" },
  { value: "RS", label: "Rio Grande do Sul" },
  { value: "RO", label: "Rondônia" },
  { value: "RR", label: "Roraima" },
  { value: "SC", label: "Santa Catarina" },
  { value: "SP", label: "São Paulo" },
  { value: "SE", label: "Sergipe" },
  { value: "TO", label: "Tocantins" },
  { value: "EX", label: "Estrangeiro" },
];

export const maskData = (v) => {
  if (v !== null && v !== undefined) {
    var dd = String(v.getDate()).padStart(2, "0");
    var mm = String(v.getMonth() + 1).padStart(2, "0");
    var yyyy = v.getFullYear();
    var dataFormatadaApi = yyyy + "-" + mm + "-" + dd;
    return dataFormatadaApi;
  }
};

export const maskDataCadastro = (v) => {
  if (v !== null && v !== undefined) {
    var dd = String(v.getDate()).padStart(2, "0");
    var mm = String(v.getMonth() + 1).padStart(2, "0");
    var yyyy = v.getFullYear();
    var dataFormatadaApi = dd + "/" + mm + "/" + yyyy;
    return dataFormatadaApi;
  }
};

export const convertDateToFormattedString = (dateString) => {
  const date = new Date(dateString);
  date.setHours(date.getHours() - 3);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear());
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${day}/${month}/${year} às ${hours}:${minutes}:${seconds}`;
};
export const getCdAplicacao = (cdAplicacao, modeloMidia) => {
  const result = modeloMidia.filter((modelo) => modelo.id === cdAplicacao);
  return result.nome;
};

export const menor12Anos = (dataNascimentoStr) => {
  const partesData = dataNascimentoStr.split("/");
  const dia = parseInt(partesData[0]);
  const mes = parseInt(partesData[1]) - 1; // Mês começa do zero no Date()
  const ano = parseInt(partesData[2]);
  const dataNascimento = new Date(ano, mes, dia);
  const dataAtual = new Date();
  const diffMs = dataAtual.getTime() - dataNascimento.getTime();
  const diffAnos = diffMs / (1000 * 60 * 60 * 24 * 365.25);
  return diffAnos < 12;
};

export const menor18Anos = (dataNascimentoStr) => {
  const dataNascimento = new Date(dataNascimentoStr);
  const dataAtual = new Date();
  let idade = dataAtual.getFullYear() - dataNascimento.getFullYear();
  const mesAtual = dataAtual.getMonth();
  const diaAtual = dataAtual.getDate();
  const mesNascimento = dataNascimento.getMonth();
  const diaNascimento = dataNascimento.getDate();

  if (
    mesAtual < mesNascimento ||
    (mesAtual === mesNascimento && diaAtual < diaNascimento)
  ) {
    idade--;
  }
  return idade < 18;
};

export const maskDataHistorico = (v) => {
  var objToday = new Date(v),
    domEnder = (function () {
      var a = objToday;
      a.setHours(objToday.getHours() + 3);
      if (/1/.test(parseInt((a + "").charAt(0)))) return "0";
      a = parseInt((a + "").charAt(1));
      return 1 === a ? "" : 2 === a ? "" : 3 === a ? "" : "";
    })(),
    dayOfMonth =
      objToday.getDate() < 10
        ? "0" + objToday.getDate() + domEnder
        : objToday.getDate() + domEnder,
    months = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ],
    curMonth = months[objToday.getMonth()],
    curYear = objToday.getFullYear(),
    curHour =
      objToday.getHours() > 12
        ? objToday.getHours() - 3
        : objToday.getHours() < 10 && objToday.getHours() > 2
          ? "0" + objToday.getHours() - 3
          : objToday.getHours() === 2
            ? "23"
            : objToday.getHours() === 1
              ? "22"
              : "21",
    curMinute =
      objToday.getMinutes() < 10
        ? "0" + objToday.getMinutes()
        : objToday.getMinutes(),
    curSeconds =
      objToday.getSeconds() < 10
        ? "0" + objToday.getSeconds()
        : objToday.getSeconds();

  var dataFormatadaApi =
    dayOfMonth +
    "/" +
    curMonth +
    "/" +
    curYear +
    " às " +
    curHour +
    ":" +
    curMinute +
    ":" +
    curSeconds;
  return dataFormatadaApi;
};

export const maskDataLaudoImpressao = (v) => {
  var objToday = new Date(v),
    domEnder = (function () {
      var a = objToday;
      a.setHours(objToday.getHours());
      if (/1/.test(parseInt((a + "").charAt(0)))) return "0";
      a = parseInt((a + "").charAt(1));
      return 1 === a ? "" : 2 === a ? "" : 3 === a ? "" : "";
    })(),
    dayOfMonth =
      objToday.getDate() < 10
        ? "0" + objToday.getDate() + domEnder
        : objToday.getDate() + domEnder,
    months = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ],
    curMonth = months[objToday.getMonth()],
    curYear = objToday.getFullYear(),
    curHour =
      objToday.getHours() > 12
        ? objToday.getHours() - 3
        : objToday.getHours() < 10 && objToday.getHours() > 2
          ? "0" + objToday.getHours() - 3
          : objToday.getHours() === 2
            ? "23"
            : objToday.getHours() === 1
              ? "22"
              : "21",
    curMinute =
      objToday.getMinutes() < 10
        ? "0" + objToday.getMinutes()
        : objToday.getMinutes(),
    curSeconds =
      objToday.getSeconds() < 10
        ? "0" + objToday.getSeconds()
        : objToday.getSeconds();

  var dataFormatadaApi =
    dayOfMonth +
    "/" +
    curMonth +
    "/" +
    curYear +
    " às " +
    curHour +
    ":" +
    curMinute +
    ":" +
    curSeconds;
  return dataFormatadaApi;
};

export const maskDataInfo = (v) => {
  var objToday = new Date(v),
    domEnder = (function () {
      var a = objToday;
      if (/1/.test(parseInt((a + "").charAt(0)))) return "0";
      a = parseInt((a + "").charAt(1));
      return 1 === a ? "" : 2 === a ? "" : 3 === a ? "" : "";
    })(),
    dayOfMonth =
      objToday.getDate() < 10
        ? "0" + objToday.getDate() + domEnder
        : objToday.getDate() + domEnder,
    months = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ],
    curMonth = months[objToday.getMonth()],
    curYear = objToday.getFullYear();

  var dataFormatadaApi = dayOfMonth + "/" + curMonth + "/" + curYear;
  return dataFormatadaApi;
};

export const convertDataRastreio = (dateTime) => {
  const [dateAndTime] = dateTime.split(".");
  return dateAndTime;
};

export const convertData = (data) => {
  const partes = data.split("/");
  const ano = partes[2];
  const mes = partes[1].padStart(2, "0");
  const dia = partes[0].padStart(2, "0");
  return `${ano}-${mes}-${dia}`;
};

export const maskDataContaVirtual = (v) => {
  var objToday = new Date(v),
    domEnder = (function () {
      var a = objToday;
      if (/1/.test(parseInt((a + "").charAt(0)))) return "";
      a = parseInt((a + "").charAt(1));
      return 1 === a ? "" : 2 === a ? "" : 3 === a ? "" : "";
    })(),
    dayOfMonth =
      objToday.getDate() < 10
        ? "0" + objToday.getDate() + domEnder
        : objToday.getDate() + domEnder,
    months = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ],
    curMonth = months[objToday.getMonth()],
    curYear = objToday.getFullYear();
  var dataFormatadaApi = curYear + "-" + curMonth + "-" + dayOfMonth;
  return dataFormatadaApi;
};

export const formatarParaMoeda = (valor) => {
  return valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

export const calcularIdade = (dataNascimentoString) => {
  const partesData = dataNascimentoString.split("-");
  const anoNascimento = parseInt(partesData[0]);
  const mesNascimento = parseInt(partesData[1]) - 1; // Mês começa do 0
  const diaNascimento = parseInt(partesData[2]);
  const dataNascimento = new Date(anoNascimento, mesNascimento, diaNascimento);
  const hoje = new Date();
  let idade = hoje.getFullYear() - dataNascimento.getFullYear();
  const mesAtual = hoje.getMonth();
  const diaAtual = hoje.getDate();
  if (
    mesAtual < mesNascimento ||
    (mesAtual === mesNascimento && diaAtual < diaNascimento)
  ) {
    idade--;
  }
  return idade;
};

export const maskDataHistoricoSemHora = (v) => {
  const data = new Date(v);
  const dia = data.getUTCDate().toString().padStart(2, "0");
  const mes = (data.getUTCMonth() + 1).toString().padStart(2, "0");
  const ano = data.getUTCFullYear();
  return `${dia}/${mes}/${ano}`;
};

export const maskDataLaudoSemHora = (v) => {
  var objToday = new Date(v);
  objToday.setDate(objToday.getDate());
  var domEnder = (function () {
    var a = objToday;
    if (/1/.test(parseInt((a + "").charAt(0)))) return "";
    a = parseInt((a + "").charAt(1));
    return [1, 2, 3].includes(a) ? "" : "";
  })();

  var dayOfMonth =
    objToday.getDate() < 10
      ? "0" + objToday.getDate() + domEnder
      : objToday.getDate() + domEnder;

  var months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  var curMonth = months[objToday.getMonth()];
  var curYear = objToday.getFullYear();

  var dataFormatadaApi = dayOfMonth + "/" + curMonth + "/" + curYear;
  return dataFormatadaApi;
};

export const maskDataLaudoSemHoraMaisUm = (v) => {
  var objToday = new Date(v);
  objToday.setDate(objToday.getDate());
  var domEnder = (function () {
    var a = objToday;
    if (/1/.test(parseInt((a + "").charAt(0)))) return "";
    a = parseInt((a + "").charAt(1));
    return [1, 2, 3].includes(a) ? "" : "";
  })();

  var dayOfMonth =
    objToday.getDate() < 10
      ? "0" + objToday.getDate() + domEnder
      : objToday.getDate() + domEnder;

  var months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  var curMonth = months[objToday.getMonth()];
  var curYear = objToday.getFullYear();

  var dataFormatadaApi = dayOfMonth + "/" + curMonth + "/" + curYear;
  return dataFormatadaApi;
};

export const maskDataHistoricoSemHoraAvulso = (v) => {
  var objToday = new Date(v);
  objToday.setDate(objToday.getDate());
  var domEnder = (function () {
    var a = objToday;
    if (/1/.test(parseInt((a + "").charAt(0)))) return "";
    a = parseInt((a + "").charAt(1));
    return [1, 2, 3].includes(a) ? "" : "";
  })();

  var dayOfMonth =
    objToday.getDate() < 10
      ? "0" + objToday.getDate() + domEnder
      : objToday.getDate() + domEnder;

  var months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  var curMonth = months[objToday.getMonth()];
  var curYear = objToday.getFullYear();
  var dataFormatadaApi = dayOfMonth + "/" + curMonth + "/" + curYear;
  return dataFormatadaApi;
};

export const maskCaracterEspecial = (cpf) => {
  if (cpf.length === 14) {
    const cpfNumerico = cpf.replace(/\D/g, "");
    const parte3 = cpfNumerico.substring(6, 9);
    const parte4 = cpfNumerico.substring(9);
    return `***.***.${parte3}-${parte4}`;
  } else {
    return cpf;
  }
};

export const isEmail = (email) => {
  var regexp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regexp.test(String(email).toLowerCase());
};

export const maskSemPontos = (v) => {
  return v.replace(/[^\d]+/g, "");
};

export const verificarIdadeMinima = (dataNascimento) => {
  const hoje = new Date();
  const idadeMinima = 5;
  const diff = hoje.getTime() - dataNascimento.getTime();
  const idadeEmAnos = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));
  return idadeEmAnos >= idadeMinima;
};

export const validaMaioIdade = (data) => {
  var hoje = new Date();
  var nasc = new Date(data);
  var idade = hoje.getFullYear() - nasc.getFullYear();
  var m = hoje.getMonth() - nasc.getMonth();
  if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) idade--;

  if (idade < 18) {
    return false;
  }

  if (idade >= 18) {
    return true;
  }

  return false;
};

export const IsCPF = (cpf) => {
  if (typeof cpf !== "string") return false;
  if (cpf === "") return false;
  cpf = cpf.replace(/[\s.-]*/gim, "");
  if (
    !cpf ||
    cpf.length !== 11 ||
    cpf === "00000000000" ||
    cpf === "11111111111" ||
    cpf === "22222222222" ||
    cpf === "33333333333" ||
    cpf === "44444444444" ||
    cpf === "55555555555" ||
    cpf === "66666666666" ||
    cpf === "77777777777" ||
    cpf === "88888888888" ||
    cpf === "99999999999"
  ) {
    return false;
  }
  var soma = 0;
  var resto;
  for (var i = 1; i <= 9; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10))) return false;
  soma = 0;
  for (let i = 1; i <= 10; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(10, 11))) return false;
  return true;
};

export const formatCurrencyFloor = (value) => {
  const str = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 3,
  }).format(new Decimal(value).toDecimalPlaces(3).toDP(3).toNumber());
  return str.slice(0, -1);
};

export const formatReal = (value) => {
  const formatedValue = new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
  }).format(value / 100);
  return formatedValue.replace(/^R\$/, "");
};

export const formatValorApi = (value) => {
  const formatedValue = new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
  }).format(value / 100);
  return formatedValue;
};

export const parseJwt = (token) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(""),
  );

  return JSON.parse(jsonPayload);
};

export const downloadPDF = (base64, fileName) => {
  const downloadLink = document.createElement("a");
  downloadLink.href = base64;
  downloadLink.download = fileName;
  downloadLink.click();
};

export const formatDataTimeStamp = (data) => {
  if (!data || typeof data !== "string") return "N/A";
  var dt = data.split("T");
  if (dt.length < 2) return "N/A";
  var dataSplit = dt[0].split("-");
  var horaSplit = dt[1].split(":");
  return (
    dataSplit[2] +
    "/" +
    dataSplit[1] +
    "/" +
    dataSplit[0] +
    " às " +
    horaSplit[0] +
    ":" +
    horaSplit[1] +
    "hrs"
  );
};

export const formatDataTimeStampSemHora = (hora) => {
  const data = new Date(hora);

  const dia = String(data.getDate()).padStart(2, "0");
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const ano = data.getFullYear();

  const horas = String(data.getHours()).padStart(2, "0");
  const minutos = String(data.getMinutes()).padStart(2, "0");

  return `${dia}/${mes}/${ano} às ${horas}:${minutos}`;
};

export const formatData = (data) => {
  var dt = data.split("-");
  return dt[2] + "/" + dt[1] + "/" + dt[0];
};

export const validaCnsProv = (cns) => {
  if (cns.trim().length !== 15) {
    return false;
  }

  let soma = 0;

  for (let i = 0; i < 15; i++) {
    soma += parseInt(cns.charAt(i)) * (15 - i);
  }

  const resto = soma % 11;

  if (resto !== 0) {
    return false;
  } else {
    return true;
  }
};

export const isDataCancelada = (dateStr) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // zera horas para comparar só a data

  const givenDate = new Date(dateStr);
  givenDate.setHours(0, 0, 0, 0);

  return givenDate < today;
};

export const getTipoPagamento = (
  idProduto,
  isSenior,
  tipoPedidoCartao,
  onViewRatioEndereco,
  apresentouBoletimDeOcorrencia,
) => {
  const isPrimeiraVia = tipoPedidoCartao === "PODE SOLICITAR PRIMEIRA_VIA";
  const isSegundaVia = tipoPedidoCartao === "PODE SOLICITAR SEGUNDA_VIA";
  const isEntregaLoja = onViewRatioEndereco === "loja";
  let isPedidoGratuito = false;
  let tipoPagamento;
  if (isPrimeiraVia && isEntregaLoja) {
    isPedidoGratuito = true;
  }
  if (isPrimeiraVia && isSenior && idProduto === 3) {
    isPedidoGratuito = true;
  }
  if (isSegundaVia && isEntregaLoja && apresentouBoletimDeOcorrencia) {
    isPedidoGratuito = true;
  }

  if (isPedidoGratuito) {
    tipoPagamento = ["GRATUITO"];
  } else {
    tipoPagamento = ["BOLETO"];
  }
  return tipoPagamento;
};

export const verificarSePossuiTaxaDeEntrega = (
  idProduto,
  isSenior,
  tipoPedidoCartao,
  onViewRatioEndereco,
) => {
  const isPrimeiraVia = tipoPedidoCartao === "PODE SOLICITAR PRIMEIRA_VIA";
  const isEntregaLoja = onViewRatioEndereco === "loja";

  let possuiTaxaDeEntrega = true;

  if (isPrimeiraVia && isSenior && idProduto === 3) {
    possuiTaxaDeEntrega = false;
  }
  if (isEntregaLoja) {
    possuiTaxaDeEntrega = false;
  }

  return possuiTaxaDeEntrega;
};

export const getUserProfiles = () => {
  const storageString = window.localStorage.getItem("user");
  const parsed = JSON.parse(storageString);
  return parsed.perfis;
};

export const isAbleToGiveGratuidade = () => {
  const userProfiles = getUserProfiles();
  const allowedProfiles = [
    Profiles.Administrador,
    Profiles.Atendimento_Gratuidade_Concessao,
    //todo depois tirar quando o perfil de concessao estiver pronto
    Profiles.Atendente,
    Profiles.AtendenteAuditoria,
    Profiles.Supervisor,
    Profiles.Supervisor_PCD,
    Profiles.Supervisor_Estudante,
    Profiles.Supervisor_SENIOR,
    Profiles.Cadastro_Estudante,
    Profiles.Cadastro_PCD,
    Profiles.Cadastro_Prefeitura,
    Profiles.Cadastro_SENIOR,
    Profiles.Medico_PCD,
  ];

  return allowedProfiles.some((profile) => userProfiles.includes(profile));
};

